import { isEmpty } from 'lodash-es';
import isNil from 'lodash-es/isNil';
import { useMemo, useState } from 'react';
import { useClient } from '../../../ClientProvider';
import useMutation from '../../../useMutation';
import useQuery from '../../../useQuery';
import { capitalize } from './utils';
const EMPTY_DEPARTMENT_RESPONSE = [];
export const useDecitraitConfigureUser = ({ org, onSuccess, onError }) => {
    const client = useClient();
    const [areaId, setAreaId] = useState(undefined);
    const [configureUser, configureUserRequest] = useMutation(client.decitrait.configureUser(), {
        onSuccess,
        onError
    });
    const organizationId = org?.id;
    const resourcesRequest = useQuery(client.decitrait.getResources({ organizationId }), {
        refetchOnWindowFocus: false
    });
    const departmentsRequest = useQuery(client.decitrait.departmentsByArea({ organizationId, areaId: areaId }), { enabled: !isNil(areaId) && !isEmpty(areaId), refetchOnWindowFocus: false });
    const availableDepartments = departmentsRequest.data ?? EMPTY_DEPARTMENT_RESPONSE;
    const departmentIdOptions = useMemo(() => availableDepartments.map((x) => {
        const [departmentNumber, departmentName] = x.name.split(' - ');
        return {
            value: x.id,
            label: `${departmentNumber} - ${capitalize((departmentName || '').toLowerCase())}`
        };
    }), [availableDepartments]);
    function onAreaIdChange(newId) {
        setAreaId(newId);
    }
    return {
        configureUser,
        configureUserRequest,
        departmentIdOptions,
        departmentsRequest,
        onAreaIdChange,
        resourcesRequest
    };
};
